import constants from "../../constants";
import React, { useContext } from "react";
import HalfDonutChart from "../HalfDonutChart";
import AlertContext from "../../context/AlertContext";
import CodingHeaderLearnerSideHooks from "../../Hooks/CodingPage/CodingHeaderLearnerSideHooks";

export default function CodingPageSuccessNotify(Props) {
  const Alert = useContext(AlertContext);

  const testHeader = CodingHeaderLearnerSideHooks();

  return !Props.timedOut ? (
    <div>
      {Props.isChart && !isNaN(Props.achievedpercent) && (
        <div>
          <HalfDonutChart
            targetPercentage={Props.targetPercent}
            achievedPercentage={Math.round(Props.achievedpercent)}
          />
          <div className="after-submit-container">
            <div className="after-submit-header">Congratulations!!</div>
            <div className="after-submit-msg">
              You Scored {Props.achievedpercent ? Math.round(Props.achievedpercent) : 0}%
            </div>
            {Props.explanation && (
              <div className="after-submit-msg">
                Explanation: {Props.explanation}
              </div>
            )}
          </div>
        </div>
      )}
      <div>
        <ul className="modalInstructionBodyunorderedListWithSuccess">
          {!Alert.testData.notebook && <li className="modalInstructionBodyTextList">
            {testHeader.getSuccessMsg()}
          </li>}
          <li className="modalInstructionBodyTextList">
            Your code has been submitted
            {!Alert.testData.notebook && !Props.codeDetails.istestcases
              ? " and evaluated."
              : " successfully."}
          </li>
          {!Alert.testData.notebook && !Props.codeDetails.istestcases && (
            <li className="modalInstructionBodyTextList">
              All the test cases have passed.
            </li>
          )}
        </ul>
      </div>
    </div>
  ) : (
    <div>
      {Props.isChart && !isNaN(Props.achievedpercent) && (
        <div>
          <HalfDonutChart
            targetPercentage={Props.targetPercent}
            achievedPercentage={Math.round(Props.achievedpercent)}
          />
          <div>
            <div className="after-submit-header">Congratulations!!</div>
            <div className="after-submit-msg">
              You Scored {Props.achievedpercent ? Math.round(Props.achievedpercent) : 0}%
            </div>
          </div>
        </div>
      )}
      <div>
        <ul className="modalInstructionBodyunorderedListWithSuccess">
          <li className="modalInstructionBodyTextList">
            {testHeader.getSuccessMsg()}
          </li>
          <li className="modalInstructionBodyTextList">
            Your code has been submitted.
          </li>
        </ul>
      </div>
    </div>
  );
}
